import { Modules } from '../../../util/modules'
import { ProductRouteNames } from '@/routes/constants/location'
import { RouteConfig } from 'vue-router'
import { requireAuthAndLocation } from '../../auth'

const ProductInventory = () =>
    import('@/pmd/pages/payments/products/ProductInventory.vue')
  const InventoryHistory = () =>
    import('@/pmd/pages/payments/products/InventoryHistory.vue')


  export const InventoryRoute: RouteConfig[] = [
 
      {
        path: 'payments/products/inventory',
        name: ProductRouteNames.inventory,
        component: ProductInventory,
        beforeEnter: requireAuthAndLocation,
        meta: { translations: [Modules.Payments] },
      },
      {
        path: 'payments/products/inventory/:productId/:priceId',
        name: ProductRouteNames.inventoryHistory,
        component: InventoryHistory,
        beforeEnter: requireAuthAndLocation,
        meta: { translations: [Modules.Payments] },
      },
  ]